import { useUser } from '@renderer/chat'
import { useDeviceUUID } from '@renderer/hooks/useDeviceUUID'
import { useCallback, useState } from 'react'
import { getInstalledVersionWithSuffix, getStartupChannel } from '@shared/utils/builds/channels.shared'
import type { PlannerVersion } from '@renderer/overlay/Sidepanel/hooks/staged-actions/confidence'

/** What the user was looking at, so support can pull its traces. */
export interface DebugInfoTarget {
  conversationId?: string
  actionId?: string
  braintrustLink?: string
  planner?: PlannerVersion
  jobId?: string
  audioSessionId?: string
  traceId?: string
  plannerSpanId?: string
}

export const useCopyDebugInfo = () => {
  const deviceUUID = useDeviceUUID()
  const user = useUser()
  const [isCopied, setIsCopied] = useState(false)

  const copyDebugInfo = useCallback(
    (target?: DebugInfoTarget) => {
      setIsCopied(true)
      navigator.clipboard.writeText(
        JSON.stringify(
          {
            debugId: user?.id,
            deviceId: deviceUUID,
            channel: getStartupChannel(),
            version: getInstalledVersionWithSuffix(),
            ...target,
          },
          null,
          2,
        ),
      )
      setTimeout(() => {
        setIsCopied(false)
      }, 2000)
    },
    [deviceUUID, user],
  )

  return { isCopied: isCopied, copyDebugInfo }
}
